import { RegitrationOrganization } from './registration-organization.model';
import { RegistrationUser } from './registration-user.model';

export class UserRegistration
{
    public Organization: RegitrationOrganization;
    public User: RegistrationUser;
    public Password: string;
    public ConfirmPassword: string;
    public AcceptTerms: boolean;

    constructor(json: object)
    {
        this.Organization = new RegitrationOrganization();
        this.User = new RegistrationUser();

        this.Organization.Name = json['businessName'];
        this.Organization.Addr1 = json['address1'];
        this.Organization.Addr2 = json['address2'];
        this.Organization.Country = json['country'];
        this.Organization.City = json['city'];
        this.Organization.State = json['state'];
        this.Organization.PostalCode = json['zipCode'];
        this.Organization.Phone = json['phone'];
        this.User.FName = json['firstName'];
        this.User.LName = json['lastName'];
        this.User.Email = json['email'];
        this.Password = json['password'];
        this.ConfirmPassword = json['confirmPassword'];
        this.AcceptTerms = json['terms'];

    }
}
